import { Base } from '@studiometa/js-toolkit';
import Menu from './Menu.js';

export default class MenuGroup extends Base {
  static config = {
    name: 'MenuGroup',
    components: {
      Menu,
    },
  }

  onMenuOpen(index) {
    this.$children.Menu.forEach((menu, i) => {
      if (index !== i) {
        menu.close();
      }
    })
  }
}
